import {
  ChatContextEntityRef,
  ChatContextEntityType,
} from "@mapmycustomers/shared/types/chat/ChatMessage";
import {
  FieldAgentContext,
  RecordContext,
  UnpinnedFieldAgentContext,
} from "@mapmycustomers/shared/types/chat/FieldAgentContext";

export interface ContextRequestFields {
  context?: FieldAgentContext;
  contextEntityId?: number;
  contextEntityType?: ChatContextEntityType;
}

// The one place the chat request's context fields are built; drop the flat pair here after ENG-2379.
const buildContextRequestFields = (
  context: undefined | UnpinnedFieldAgentContext,
  pinned: boolean
): ContextRequestFields => {
  if (!context) {
    return {};
  }
  return {
    context: pinned ? { ...context, pinned: true } : context,
    ...(context.record
      ? {
          contextEntityId: context.record.entityId,
          contextEntityType: context.record.entityType,
        }
      : {}),
  };
};

// The record context for a thread that is anchored to one record.
export const toRecordContext = (
  entity: ChatContextEntityRef | undefined
): RecordContext | undefined =>
  entity && typeof entity.id === "number"
    ? { record: { entityId: entity.id, entityType: entity.entityType }, screen: "record" }
    : undefined;

export default buildContextRequestFields;
